import api from './api';

const practiceAnalyticsService = {
  getSummary: () => api.get('/practice-analytics/summary'),
  getQueue: () => api.get('/practice-analytics/queue'),
  getFollowUps: () => api.get('/practice-analytics/follow-ups'),
  getTeam: () => api.get('/practice-analytics/team'),
  getCpt: () => api.get('/practice-analytics/cpt')
};

export default practiceAnalyticsService;
